import { render, staticRenderFns } from "./PopularHotels.vue?vue&type=template&id=c7a94616&"
import script from "./PopularHotels.vue?vue&type=script&lang=js&"
export * from "./PopularHotels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports